import { attr, customElement, GenesisElement } from '@genesislcap/web-core';
import { principalAmountModalStyles as styles } from './principal-amount-modal.styles';
import { principalAmountModalTemplate as template } from './principal-amount-modal.template';

@customElement({
  name: 'principal-amount-modal',
  template,
  styles,
})
export class PrincipalAmountModal extends GenesisElement {
  @attr({ mode: 'boolean' }) visible = false;

  @attr({ attribute: 'anchor-top' }) anchorTop = '0';

  @attr({ attribute: 'anchor-left' }) anchorLeft = '0';

  @attr({ attribute: 'principal-amount' }) principalAmount: string | null = null;

  @attr({ attribute: 'value-highlighted', mode: 'boolean' }) valueHighlighted = false;
}
